<template>
  <MainViewFrame>
    <div class="detailCompany" ref="detailCompany">
      <div class="item" v-if="currentCompany">
        <div class="logo"><img :src="getImg(currentCompany.logo)" /></div>
        <div class="rightView">
          <span class="title">
            {{ currentCompany.name }}
            <img v-if="currentCompany.is_ceo" class="icon" :src="images.update" @click="updateCompany()"/>
            <span v-if="currentCompany.is_member" class="inviteIcon" @click="inviteEvent()">
              <img :src="images.invite" />
              邀请新用户，各得1000蓝钻
            </span>
            
          </span>
          <p class="content">{{ currentCompany.content }}</p>
          <p class="desc">
            <span class="position"
              >公司收入: {{ currentCompany.total_income }}蓝钻</span
            >
            <span class="product"
              >公司现有资产: {{ currentCompany.exist_income }}蓝钻</span
            >
            <!-- <span class="income" @mouseenter="showTipView()" @mouseleave="hideTipView()">公司如何赚取更多蓝钻？</span> -->
          </p>
          <div class="tipView" v-if="show_tip">
            <img class="arrow" :src="images.tip_arrow" />
            <div class="tip">1、邀请新用户注册加入公司：邀请一个用户，公司和用户各得1000蓝钻。<br/> 2、卖产品：一个产品价值100蓝钻</div>
          </div>
        </div>
      </div>

      <div class="tabs">
        <span
          :class="`tab ${tag === 'product' ? 'select' : ''}`"
          @click="setTag('product')"
          >公司产品</span
        >
        <span
          :class="`tab ${tag === 'member' ? 'select' : ''}`"
          @click="setTag('member')"
          >公司成员</span
        >
        <span
          v-if="currentCompany && currentCompany.is_member"
          :class="`tab ${tag === 'meeting' ? 'select' : ''}`"
          @click="setTag('meeting')"
          >会议室</span
        >
      </div>

      <CompanyMember v-if="tag === 'member'" />
      <CompanyProduct v-else-if="tag === 'product'" />
      <CompanyMeeting v-else-if="tag === 'meeting' && currentCompany && currentCompany.is_member " />
    </div>
    <!-- 修改公司 UI -->
    <CreateCompany ref="createCompany" tag="shadow">
      <CreateCompany :current-company="currentCompany"/>
    </CreateCompany>
    <!-- 邀请好友 -->
    <CompanyPoster ref="companyPoster"/>
  </MainViewFrame>
</template>

<script>
// @ is an alias to /src
import MainViewFrame from "./MainViewFrame.vue";
import CompanyProduct from "./CompanyProduct.vue";
import CompanyMember from "./CompanyMember.vue";
import CreateCompany from './CreateCompany'
import CompanyPoster from './CompanyPoster'
import CompanyMeeting from './CompanyMeeting'

import { Utils } from "../utils";

import { types as CompanyTypes } from "../store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { IMG_TIP_ARROW_TOP, IMG_COMPANY_UPDATE_ICON, IMG_INVITE_ICON } from '../assets';

export default {
  name: "DetailCompany",
  components: {
    MainViewFrame,
    CompanyProduct,
    CompanyMember,
    CreateCompany,
    CompanyPoster,
    CompanyMeeting
  },
  props: {},
  data() {
    return {
      tag: "product",
      company_id: 0,
      images:{
        tip_arrow: IMG_TIP_ARROW_TOP,
        update: IMG_COMPANY_UPDATE_ICON,
        invite: IMG_INVITE_ICON
      },
      show_tip:false
    };
  },
  watch: {},
  computed: {
    ...mapState({
      currentCompany: state => state.company.currentCompany
    })
  },
  methods: {
    ...mapActions({
      fetchDetailCompany: CompanyTypes.FETCH_DETAIL_COMPANY
    }),
    ...Utils,

    showTipView(){
      this.show_tip = true
    },
    hideTipView(){
      this.show_tip = false
    },
    setTag(tag) {
      this.tag = tag;
    },
    updateCompany(){
      this.$refs.createCompany.showShadowView()
    },
    inviteEvent(){
      // 邀请好友
      this.$refs.companyPoster.show(this.company_id)
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    let company_id = this.$route.params.company_id;
    this.company_id = company_id;
    this.fetchDetailCompany({ pk: company_id });
  }
};
</script>

<style lang="less" scoped>
.detailCompany {
  width: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  min-height: 500px;
  overflow: hidden;
  .item {
    display: flex;
    flex-direction: row;
    // align-items: center;
    padding: 15px;
    padding-bottom: 0;
    .logo {
      width: 100px;
      height: 100px;
      margin-right: 15px;
      border-radius: 8px;
      background-color: #F4F3F3;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      img{
        width: 100%;
        max-height: 100%;
      }
    }
    .rightView {
      flex: 1;
      // height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      .title {
        color: #333333;
        font-size: 15px;
        margin-bottom: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        .icon{
          margin-left: 10px;
          width: 15px;
          height: 15px;
          cursor: pointer;
        }
        .inviteIcon{
          color: #541DFF;
          font-size: 12px;
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;
          position: absolute;
          right: 0;
          img{
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
        }
      }
      .content {
        color: #666666;
        font-size: 13px;
        line-height: 23px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: 5px;
        // height: 50px;
      }
      .desc {
        display: flex;
        flex-direction: row;
        color: #999999;
        font-size: 13px;
        position: relative;
        .position {
          margin-right: 30px;
          color: #6b45e1;
          color: #333333;
        }
        .product {
          margin-right: 10px;
          color: #f56501;
          color: #333333;
        }
        .income {
          color: #6b45e1;
          position: absolute;
          right: 0px;
          cursor: pointer;
          font-weight: bold;
        }
      }
      
      .tipView {
        position: absolute;
        right: 0px;
        bottom: -120px;
        z-index: 666;
        .arrow {
          // width: 30px;
          height: 22px;
              margin-left: 88%;
        }
        .tip {
          background-color: #fff8e3;
          border: solid 5px #6b45e1;
          border-radius: 10px;
          font-size: 14px;
          color: #333333;
          padding: 10px 20px;
    line-height: 30px;
        height: 60px;
        }
      }
    }
  }
  .tabs {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-top: 18px;
    .tab {
      color: #666666;
      font-size: 15px;
      margin-left: 15px;
      margin-right: 15px;
      padding-bottom: 3px;
      cursor: pointer;
      &.select {
        color: #ff7b00;
        border-bottom: solid 1.5px #f56501;
        font-weight: bold;
      }
    }
  }
}
</style>
